import styled from 'styled-components';
import type { useRichTextEditor } from '~/hooks/useRichTextEditor';
import { FormattingToolbar, type ToolbarItem } from './FormattingToolbar';
import { RichTextEditor } from './RichTextEditor';

interface BorderedRichTextEditorProps {
  editor: ReturnType<typeof useRichTextEditor>;
  onSubmit?: () => void;
  visibleTools?: ToolbarItem[];
  maxHeight?: string;
  placeholder?: string;
  disabled?: boolean;
  id?: string;
}

export function BorderedRichTextEditor({
  editor,
  onSubmit,
  visibleTools,
  maxHeight,
  placeholder,
  disabled,
  id,
}: BorderedRichTextEditorProps) {
  const {
    editorRef,
    applyFormat,
    insertList,
    insertBlockquote,
    applyLink,
    saveSelection,
    handleKeyDown,
  } = editor;

  return (
    <Wrapper $disabled={disabled}>
      <FormattingToolbar
        alternate
        visibleTools={visibleTools}
        onBold={() => applyFormat('bold')}
        onItalic={() => applyFormat('italic')}
        onUnderline={() => applyFormat('underline')}
        onBulletList={() => insertList(false)}
        onNumberedList={() => insertList(true)}
        onBlockquote={insertBlockquote}
        onLink={() => {
          saveSelection();
          const url = window.prompt('URL');
          if (url) applyLink(url);
        }}
      />
      <RichTextEditor
        ref={editorRef}
        id={id}
        maxHeight={maxHeight}
        placeholder={placeholder}
        onKeyDown={(e) => handleKeyDown(e, onSubmit ?? (() => {}))}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div<{ $disabled?: boolean }>`
  border: 1px solid var(--grey-300);
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  overflow: hidden;
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
`;
